/** Dados iniciais extraídos da página pública /regras — usados como seed do CMS. */
export type RulesSeedRow = {
  id: number;
  title: string;
  category: string;
  updated: boolean;
  content: string[];
};

export const RULES_SEED: RulesSeedRow[] = [
  {
    id: 1,
    title: 'Ajudar é a prioridade principal',
    category: 'Comportamento',
    updated: false,
    content: [
      'Como um chat de ajuda, damos prioridade aos usuários que precisam de auxílio. Caso outros assuntos estejam interferindo no atendimento, a equipe poderá recomendar uma pausa, o uso de chat privado, gag temporário ou kick em casos de má fé.',
    ],
  },
  {
    id: 2,
    title: 'Apenas converse em Português',
    category: 'Comportamento',
    updated: false,
    content: [
      'O chat presta ajuda somente em Português. Para outros idiomas, existem grupos capazes de prestar apoio a estrangeiros. Caso conversem em outro idioma, serão redirecionados para salas adequadas. Mensagens de saudações, como "Hola", "Hello", "Selam", "Ciao", etc., são toleradas.',
    ],
  },
  {
    id: 3,
    title: 'Seja sempre apropriado',
    category: 'Conteúdo',
    updated: true,
    content: [
      'Este chat é um ambiente de ajuda e deve ser adequado para usuários a partir de 14 anos. Não é permitido enviar, divulgar ou insinuar qualquer conteúdo impróprio para menores de 18 anos, incluindo mensagens, imagens, links, home-pages, nomes, avatars, status, músicas ou qualquer tipo de mídia.',
      'Também não é permitido usar smilies, gifs, imagens, "kisses", "hugs" ou qualquer conteúdo com conotação sexual, obscena, maliciosa, chocante ou sugestiva, mesmo que seja "em brincadeira".',
      'Caso ocorra, a equipe poderá remover o conteúdo e aplicar advertências, kicks ou punições temporárias conforme a gravidade e a reincidência.',
    ],
  },
  {
    id: 4,
    title: 'Respeite todos no chat',
    category: 'Segurança',
    updated: false,
    content: [
      'Este é um ambiente de ajuda, então o respeito é essencial. Não são permitidas ofensas, provocações, discriminação, racismo, bullying, ataques pessoais ou qualquer forma de assédio.',
      'Brincadeiras são bem-vindas quando todos estão confortáveis, mas qualquer atitude que constranja, humilhe ou cause desconforto a outro usuário não será tolerada.',
      'Caso isso aconteça, a equipe poderá aplicar advertências ou punições temporárias conforme a situação.',
    ],
  },
  {
    id: 5,
    title: 'Não faça propaganda',
    category: 'Comportamento',
    updated: false,
    content: [
      'É proibido anunciar sites que não sejam do xat.com ou não sejam liberados pelo xat.com. Anunciar chats não oficiais é proibido. Para ver a lista de chats oficiais e tributos, clique aqui. Serão tolerados links de sites e de qualquer chat, desde que estejam na home-page, no status ou no PCBack. No entanto, qualquer forma de anúncio será advertida.',
    ],
  },
  {
    id: 6,
    title: 'Não personifique outros usuários',
    category: 'Comportamento',
    updated: false,
    content: [
      'É proibido se passar por outros usuários, fazendo alterações no nome, status, foto ou tentando fraudar outras pessoas, incluindo a personificação de voluntários ou membros da equipe do Ajuda na tentativa de fraude. Serão aplicadas advertências imediatas.',
    ],
  },
  {
    id: 7,
    title: 'Não implore ou peça por produtos de graça',
    category: 'Sistema',
    updated: true,
    content: [
      'É proibido pedir por xats, days, powers ou qualquer outro produto do xat. Você pode encontrar mais informações clicando aqui.',
    ],
  },
  {
    id: 8,
    title: 'Não implore ou peça por cargos na equipe',
    category: 'Segurança',
    updated: false,
    content: [
      'É proibido pedir por cargos na equipe, seja no chat principal ou por privado. A seleção é feita com base na meritocracia, convidando os usuários mais ativos, prestativos e exemplares.',
    ],
  },
  {
    id: 9,
    title: 'Spam não é permitido',
    category: 'Sistema',
    updated: false,
    content: [
      'O spam de smiley é enviar mais de seis smilies em uma mensagem. Se outras pessoas relatarem lag ou se a equipe considerar excessivos os smilies de alguém em seu nome (por exemplo, 6+ smilies), o usuário pode ser solicitado a remover os smilies de seu nome. Postar várias mensagens consecutivamente (quando evitável ou feito propositadamente) é considerado flood, normalmente em torno de 6 ou mais mensagens seguidas. Adicionar muitos caracteres extras a uma palavra é aceitável, até certo ponto. Isso envolve a interpretação do moderador e você pode ser avisado se a equipe considerar suas mensagens como spam.',
    ],
  },
  {
    id: 10,
    title: 'O uso do Caps Lock é restrito',
    category: 'Comportamento',
    updated: false,
    content: [
      'Em casos específicos, a equipe tem autorização para fazer utilização do caps lock. Até 3 palavras em caps lock são permitidas. O uso excessivo é passível de punição.',
    ],
  },
  {
    id: 11,
    title: 'O uso do Size e Big é restrito',
    category: 'Comportamento',
    updated: false,
    content: [
      'O uso dos smilies Size e Big é restrito. Siga as orientações da equipe quando solicitado.',
    ],
  },
  {
    id: 12,
    title: 'Solicite e responda por Ajuda de forma educada',
    category: 'Comportamento',
    updated: false,
    content: [
      'Conforme descrito nos Termos de Serviço do xat, os usuários que solicitarem ou responderem a um pedido de ajuda devem fazer isso de maneira cortês. Os usuários fornecendo suporte no chat Ajuda fazem isso em uma base voluntária e trabalham para dar a cada visitante uma experiência positiva e justa. Queixar-se publicamente sobre as ações de um moderador não é aceitável, e quaisquer queixas devem ser enviadas para os Proprietários Principais.',
    ],
  },
  {
    id: 13,
    title: 'Falsa ajuda e falsas denúncias podem resultar em banimento',
    category: 'Segurança',
    updated: true,
    content: [
      'Prover falsa ajuda para um usuário que busca por ajuda não é permitido. Se parece que um usuário está fornecendo falsa ajuda com intenções prejudiciais ou em uma maneira obviamente sarcástica, esse usuário pode ser banido imediatamente. Erros simples, principalmente devido a informações desatualizadas, podem resultar em uma advertência ou correção. Além disso, se um usuário denunciar outro usuário com provas não genuínas, o usuário relatando pode ser banido.',
    ],
  },
  {
    id: 14,
    title: 'Todos os visitantes devem usar um nome com comprimento razoável',
    category: 'Comportamento',
    updated: false,
    content: [
      'É obrigatório que cada usuário no chat tenha um nome com um comprimento ou tamanho razoável. É tolerada a presença de uma mera letra, número ou símbolo desde que não seja deixado em branco ou feito o uso de caracteres invisíveis.',
    ],
  },
  {
    id: 15,
    title: 'O comércio geralmente não é permitido, com algumas exceções',
    category: 'Sistema',
    updated: true,
    content: [
      'Os usuários podem solicitar a compra de 1 (UM) day, mas somente se o usuário estiver sem. Todas as outras negociações devem ocorrer nos chats de comércio. Comprar ou vender xats, days, powers, ids, fundos, gifs é permitido apenas no status. Desenhar sinais para um status com a intenção de chamar a atenção para o(s) item(ns) que estão a venda que normalmente são proibido(s) no chat principal também não é permitido. É proibido comprar ou vender qualquer outro produto ou serviço. Comprar ou vender produtos do xat para moeda fora do site é proibido para a maioria dos usuários por razões de segurança.',
    ],
  },
  {
    id: 16,
    title: 'Não é permitido trollar, postar comentários inflamatórios ou fazer drama',
    category: 'Comportamento',
    updated: false,
    content: [
      'Trollar geralmente se refere ao ato de interromper o chat, incomodar ou tentar causar problemas. Só faça perguntas relacionadas ao xat. Como este é um chat em que os usuários recebem assistência, há pouco espaço para trollar. Nós entendemos que os usuários podem brincar dizendo que precisam de ajuda e então fazendo uma pergunta não relacionada ao xat. Isso não é considerado troll.',
      'Se esse tipo de comportamento se tornar excessivo ou prolongado, ou se o usuário tiver uma intenção óbvia de irritar outras pessoas, interromper o chat, ou se o usuário estiver sendo excessivamente desagradável, ele poderá ser solicitado a parar. Assuntos que envolvam chats externos ou usuários presentes ou ausentes no chat, serão advertidos caso contenham mensagens impróprias ou de caráter difamatório.',
      'Assuntos que tenham objetivo de denegrir um usuário, grupo ou imagem devem ser evitados e serão advertidos de acordo com o entendimento dos moderadores. Protestos de bans ou kicks não serão tolerados, independente de onde tenham acontecido. Usuários que foram punidos injustamente devem relatar aos donos do chat Cupim, Guinho, ou Thuk.',
    ],
  },
  {
    id: 17,
    title: 'Não discuta sobre hacking ou atividades relacionadas',
    category: 'Segurança',
    updated: false,
    content: [
      'A discussão sobre hacking/pirataria é estritamente proibida. Observe que dizer "Fui hackeado" não é passível de banimento, pois na verdade não está discutindo sobre hacking em si. Esta regra é deixada a critério da interpretação dos moderadores/proprietários.',
    ],
  },
  {
    id: 18,
    title: 'Fornecer ajuda insincera ou ineficaz não é permitido',
    category: 'Comportamento',
    updated: false,
    content: [
      'Se você decidir fornecer ajuda para um usuário, isso não deve ser feito de uma forma insincera. Se isso fosse permitido, isso pareceria não profissional e não genuíno. Um exemplo é simplesmente dizer à um usuário para olhar na wiki, esperando que o mesmo encontre o que precisa. Se você não está preparado para ajudar os outros, então evite ajudar. Simplesmente direcionar para uma palavra linkada, ou um artigo na wiki também é considerado não profissional e pode parecer não genuíno. Explicar como o visitante pode ser melhor ajudado vendo o recurso, e para que o recurso serve, é suficiente.',
    ],
  },
  {
    id: 19,
    title: 'Moderadores e proprietários têm a palavra final na classificação de material ofensivo',
    category: 'Comportamento',
    updated: false,
    content: [
      'Devido à natureza do idioma português, não é possível listar todos os termos ou frases ofensivas. Para instâncias menores de comportamento impróprio, o usuário será instruído a parar ou será expulso, com base no julgamento dos moderadores ou proprietários que estão testemunhando o comportamento. Se você discordar da maneira como um moderador ou proprietário lida com uma situação, espere até que uma pessoa de nível superior esteja disponível para resolver sua reclamação ou solicitação.',
    ],
  },
  {
    id: 20,
    title: 'Obedeça os Termos de Serviço do xat',
    category: 'Segurança',
    updated: true,
    content: [
      'O não cumprimento dos Termos de Serviço pode resultar em uma suspenção (ban). Os tópicos a seguir são as principais áreas a ter em conta: A exposição de informações pessoais, o abuso ou o ensino de falhas (glitches), e a pratica de phishing ou fraude. Compartilhar, discutir, ou mesmo mencionar servidores privados de qualquer tipo não é permitido, especialmente aqueles que envolvem o xat.',
    ],
  },
];

export const CONDUCT_ITEMS_SEED: string[] = [
  'Você não irá ditar regras que não existem ou repreender com elas.',
  'É necessário um motivo para cada expulsão e banimento. Os proprietários não precisam incluir os motivos dos mutes. As únicas exceções são quando você está banindo raid bots ou banindo usuários que continuam se desbanindo.',
  'Se estiver ocorrendo uma invasão (raid), use o modo de proteção /p. Se ela falhar, use o modo /pr.',
  'Se um usuário quebrar uma regra ao procurar ajuda, dê a ele mais clemência do que alguém que está aqui apenas para conversar sobre assuntos gerais.',
  'Inclua informações de violação de regras nos motivos de kick para que os usuários possam corrigir seu comportamento. Não dê apenas uma diretiva e espere que eles entendam seus erros.',
  'Consulte um usuário de nível superior ao decidir rebaixar alguém. Em casos de claro abuso, você pode rebaixar imediatamente.',
  'Não banir por longos períodos de tempo por razões mesquinhas. Um banimento de um dia pode não ser necessariamente justa para todas as violações de regras. Pense cuidadosamente sobre o que é justo e apropriado.',
  'Embora a responsabilidade principal de um proprietário seja garantir que outros membros da equipe ajudem e façam cumprir as regras de maneira eficaz, os proprietários ainda precisam ajudar.',
  'Se você é um proprietário e gostaria que alguém se tornasse um membro, sugira essa pessoa ao proprietário principal e justifique por que essa pessoa deve se tornar um membro.',
  'Os banimentos emitidos pelo bot devem ser verificados. Se o usuário precisar de ajuda, considere removê-lo do banimento.',
  'Os proprietários devem rebaixar um usuário para visitante se o mesmo quebrar uma regra e for um moderador temporário.',
  'Se um usuário não registrado relatar algo que aconteceu em um chat ou mensagem privada, não tome nenhuma atitude. Diga ao usuário apenas para utilizar os recursos de ignorar ou bloquear.',
];
